import { routes } from '@/config/routes';
import type { AdminModuleDefinition } from '@/types/adminModule';

export function resolveAdminModuleUrl(module: AdminModuleDefinition): string {
  if (module.contentType === 'external' && module.url) {
    return module.url;
  }

  const routeSegment = module.route ?? module.id;
  return `${window.location.origin}${routes.adminEmbed(routeSegment)}`;
}
